import { createRoute } from '@tanstack/react-router'
import { publicLayoutRoute } from '@/ui/pages/public'
import { OAuthCallbackHandlerSection } from './components/OauthCallbackHandlerSection'

export const oauthCallbackRoute = createRoute({
  getParentRoute: () => publicLayoutRoute,
  path: 'oauth-callback',
  component: OAuthCallbackPage,
})

export function OAuthCallbackPage() {
  return <OAuthCallbackHandlerSection />
}
